import Vue from 'vue';
import set from 'lodash.set';

const GET_REQUEST_SUBSCRIPTION_INTERVAL_PATH = "_subscriptionMinimumInterval";
const POST_REQUEST_SUBSCRIPTION_INTERVAL_PATH = "meta.subscription.minimumInterval";
const activeSubscriptions = /* @__PURE__ */ new Map();
const getSubscriptionKey = (request, payload) => {
  const url = typeof request.url === "function" ? request.url(payload) : request.url;
  return [url, JSON.stringify(payload)].join("_");
};
const getSubscriptionPropertyPath = (method, propertyPath) => {
  if (propertyPath) {
    return propertyPath;
  }
  return method === "GET" ? GET_REQUEST_SUBSCRIPTION_INTERVAL_PATH : POST_REQUEST_SUBSCRIPTION_INTERVAL_PATH;
};
const getMdg2SubscriptionData = () => (state) => (payload) => {
  var _a, _b;
  const stateKey = JSON.stringify(payload);
  return (_b = (_a = state[stateKey]) == null ? void 0 : _a.result) != null ? _b : void 0;
};
const setMdg2SubscriptionData = () => (state, payload) => {
  if (state[payload.key]) {
    state[payload.key] = payload.data;
  }
  Vue.set(state, payload.key, payload.data);
};
const fetchObservable = (request, mdg2Client, logger) => async (store, payload) => {
  const stateKey = JSON.stringify(payload);
  const subscriptionKey = getSubscriptionKey(request, payload);
  let status = true;
  if (activeSubscriptions.has(subscriptionKey)) {
    const subscription = activeSubscriptions.get(subscriptionKey);
    subscription.count++;
    return Promise.resolve(true);
  }
  try {
    const url = typeof request.url === "function" ? request.url(payload) : request.url;
    const data = request.payloadFormatter ? request.payloadFormatter(payload) : structuredClone(payload);
    const { options } = request;
    const subscriptionPropertyPath = getSubscriptionPropertyPath(request.method, request.subscription.propertyPath);
    set(data, subscriptionPropertyPath, request.subscription.minimumInterval);
    logger.debug({
      mdg2Observable: {
        type: request.method,
        url,
        payload: data,
        options
      }
    });
    const observable = mdg2Client.observeEndpoint(request.method, url, data, options);
    const subscription = observable.subscribe({
      next: (result) => {
        store.commit("setNextValue", {
          key: stateKey,
          data: {
            result: { data: result.data, meta: result.response.meta }
          }
        });
      },
      error: (error) => {
        logger.error({
          mdg2Observable: {
            type: request.method,
            url,
            payload: data,
            options
          },
          error
        });
      }
    });
    activeSubscriptions.set(subscriptionKey, { observable, subscription, count: 1 });
  } catch (error) {
    logger.error(error);
    status = false;
  }
  return Promise.resolve(status);
};
const getObservable = (request) => async (store, payload) => {
  const subscriptionKey = getSubscriptionKey(request, payload);
  if (activeSubscriptions.has(subscriptionKey)) {
    const subscription = activeSubscriptions.get(subscriptionKey);
    return Promise.resolve(subscription.observable);
  }
  return void 0;
};
const removeSubscriptionIfInactive = (request, mdg2Client, logger) => async (store, payload) => {
  const subscriptionKey = getSubscriptionKey(request, payload);
  if (activeSubscriptions.has(subscriptionKey)) {
    const subscription = activeSubscriptions.get(subscriptionKey);
    logger.debug({
      mdg2RemoveSubscription: {
        key: subscriptionKey,
        subscription
      }
    });
    subscription.count--;
    if (subscription.count <= 0) {
      subscription.subscription.unsubscribe();
      mdg2Client.unobserveEndpoint(subscription.observable.idJob);
      activeSubscriptions.delete(subscriptionKey);
    }
  }
  return Promise.resolve(true);
};
const baseMdg2SubscriptionModule = (request, mdg2Client, logger) => ({
  namespaced: true,
  state: {},
  getters: {
    getData: getMdg2SubscriptionData()
  },
  mutations: {
    setNextValue: setMdg2SubscriptionData()
  },
  actions: {
    fetchObservable: fetchObservable(request, mdg2Client, logger),
    getObservable: getObservable(request),
    removeSubscriptionIfInactive: removeSubscriptionIfInactive(request, mdg2Client, logger)
  }
});

export { baseMdg2SubscriptionModule, fetchObservable, getMdg2SubscriptionData, getObservable, removeSubscriptionIfInactive, setMdg2SubscriptionData };
